export enum HttpMethods {

    Get = 'GET'
    , Patch = 'PATCH'
    , Post = 'POST'
    , Put = 'PUT'

}